import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { InformationOutlined } from "@toddle-edu/ds-icons";
import { Button } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import classes from "./FailedMessageFooter.scss";

const FailedMessageFooter = ({ onRetryMessageClick }) => {
  const { t } = useI18n();

  return (
    <div className={classes.containerV2}>
      <div className={classes.textContainer}>
        <InformationOutlined size="xx-small" variant="critical" />
        <div
          className={classNames("text-body-3", "text-textSubtle", classes.text)}
        >
          {t("common:failed_to_send")}
        </div>
      </div>
      <div className={classNames("text-textSubtle", classes.text)}>|</div>
      <Button
        variant="inline-progressive"
        size="small"
        onClick={onRetryMessageClick}
      >
        <div className={classNames("text-label-4", classes.text)}>
          {t("common:send_again")}
        </div>
      </Button>
    </div>
  );
};

FailedMessageFooter.propTypes = {
  onRetryMessageClick: PropTypes.func.isRequired,
};

export default FailedMessageFooter;
